function addPrivateNote({ userId, metadataId, note }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/privatenotes`;
  return apiClient.post(route, { userId, metadataId, note });
}

function updatePrivateNote({ userId, noteId, note }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/privatenotes/${noteId}`;
  return apiClient.patch(route, { userId, note });
}

function removePrivateNote({ userId, noteId }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/ugc/privatenotes/${noteId}`;
  return apiClient.delete(route, { userId });
}

export default {
  addPrivateNote,
  updatePrivateNote,
  removePrivateNote
};



// WEBPACK FOOTER //
// ./app/api/PrivateNotesApi.js